import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentPage } from "../../../../../redux/slices/appSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../../../redux/slices/cmsSettingsSlice";
import EmployerMatchingNotice from "./EmployerMatchingNotice";

/**
 * @param {object} props
 * @param {number} props.controlId
 * @returns {React.JSX.Element}
 */
const ConnectedEmployerMatchingNotice = ({ controlId }) => {
    const currentPage = useSelector(selectCurrentPage);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(state, controlId, currentPage),
    );
    const {
        options: {
            matchingGiftNoticeText = "Your gift could be matched by an employer! We'll check on a later step.",
        },
    } = control;

    return <EmployerMatchingNotice noticeMessage={matchingGiftNoticeText} />;
};

export default ConnectedEmployerMatchingNotice;
